// extracted by mini-css-extract-plugin
export default {"userInput":"editName_userInput__9e7PP","buttonContainer":"editName_buttonContainer__ddeEk","editName":"editName_editName__-3hX3","buttoncontainer":"editName_buttoncontainer__x4a3f"};